angular.module('ikeweb.folders').factory('folderService', ['folderRepository', 'promiseFactory', 'localStorageService', 'folderFactory', 'orderByFilter',

        function(folderRepository, promiseFactory, localStorageService, folderFactory, orderByFilter) {

            var shown = [];
            var topLevelFolders = [];
            var firstLevelSubfolders = [];
            var flattenedList = [];

            function list() {
                return folderRepository.list();
            }

            function current() {
                return localStorageService.get('folder.current') ?
                    folderRepository.get(localStorageService.get('folder.current')) :
                    promiseFactory.promise();
            }

            function getVisibleFolders(folder) {
                return shown;
            }

            function getTopLevelFolder(folderId) {
                var topLevelFolder = null;
                if (flattenedList == null || flattenedList.length < 1) {
                    return;
                }
                //flattened list contains the folder with the tree data
                var folder = flattenedList.find(function(element) {
                    return folderId === element.getId();
                });

                if (folder.ordinal === 0) {
                    topLevelFolder = topLevelFolders.find(function(element) {
                        return folder.getId() === element.getId();
                    });
                } else if (folder.ordinal === 1) {
                    topLevelFolder = topLevelFolders.find(function(element) {
                        return folder.getParentId() === element.getId();
                    });
                } else if (folder.ordinal === 2) {
                    var firstLevelSubfolder = firstLevelSubfolders.find(function(element) {
                        return folder.getParentId() === element.getId();
                    });
                    topLevelFolder = topLevelFolders.find(function(element) {
                        return firstLevelSubfolder.getParentId() === element.getId();
                    });
                }
                return topLevelFolder;
            }

            function setVisibleFolders(folder) {
                shown = [];
                var topLevelFolder = getTopLevelFolder(folder.getId());
                if (topLevelFolder == null) {
                    return;
                }
                shown.push(topLevelFolder.getId());
                if (topLevelFolder.subFolders == null) {
                    return shown;
                }
                topLevelFolder.subFolders.forEach(function(subFolder) {
                    shown.push(subFolder.getId());
                    subFolder.subFolders.forEach(function(subSubFolder) {
                        shown.push(subSubFolder.getId());
                    });
                });

                return shown;
            }

            function setCurrent(folder) {
                if (folder == null) {
                    return undefined;
                }
                setVisibleFolders(folder);
                localStorageService.set('folder.current', folder.getId());
            }

            function rename(folder, newName) {
                if (folder.getName() === newName) {
                    return promiseFactory.resolvedPromise(folder);
                }

                var previousName = folder.getName();

                folder.setName(newName);

                return folderRepository.save(folder)
                    .catch(function(error) {
                        folder.setName(previousName);
                        return promiseFactory.rejectedPromise(error);
                    });
            }

            function createNew(name, parentId) {
                return folderRepository.create(folderFactory.fromAttributeMap({
                    name: name,
                    parentId: parentId
                }));
            }

            function deleteFolder(folder) {
                localStorageService.remove('folder.current');
                return folderRepository.destroy(folder);
            }

            function newSubfolder(folderName, parentId) {
                return createNew(folderName, parentId);
            }

            function sortFolderByParentAndName(x, y) {
                var xKey = '' + x.getParentId() + x.getName();
                var yKey = '' + y.getParentId() + y.getName();
                return xKey.localeCompare(yKey);
            }

            function orderByName(folders) {
                folders.sort(sortFolderByParentAndName);
                topLevelFolders = folders.filter(function(folder) {
                    return folder.getParentId() == null;
                });
                topLevelFolders = topLevelFolders.map(function(obj) {
                    obj.subFolders = [];
                    return obj;
                });

                firstLevelSubfolders = folders.filter(function(subFolder) {
                    return topLevelFolders.find(function(topFolder) {
                        var isChild = topFolder.getId() === subFolder.getParentId();
                        if (isChild) {
                            subFolder.subFolders = [];
                            topFolder.subFolders.push(subFolder);
                        }
                        return isChild;
                    });
                });

                folders.forEach(function(secondSubFolder) {
                    return firstLevelSubfolders.find(function(firstSubFolder) {
                        var isChild = firstSubFolder.getId() === secondSubFolder.getParentId();
                        if (isChild) {
                            firstSubFolder.subFolders.push(secondSubFolder);
                        }
                        return isChild;
                    });
                });

                flattenedList = [];
                // Ordinal levels are used for the ui to expand and collapse subfolders
                // also to indent each level as the data structure for the UI is the
                // flattened one.
                topLevelFolders.forEach(function(element, index) {
                    element.ordinal = 0;
                    flattenedList.push(element);
                    element.subFolders.forEach(function(element2, index) {
                        element2.ordinal = 1;
                        flattenedList.push(element2);
                        element2.subFolders.forEach(function(element3, index) {
                            element3.ordinal = 2;
                            flattenedList.push(element3);
                        });
                    });
                });

                return flattenedList;
            }

            return {
                list: list,
                current: current,
                setCurrent: setCurrent,
                rename: rename,
                createNew: createNew,
                deleteFolder: deleteFolder,
                newSubfolder: newSubfolder,
                orderByName: orderByName,
                getVisibleFolders: getVisibleFolders

            };
        }
    ])
    .config(['$provide', function($provide) {

        var functionsToDecorate = [
            'list',
            'current',
            'rename',
            'createNew',
            'deleteFolder'
        ];

        $provide.decorator('folderService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService', 'cloudCodeErrors', 'loggingDecorator',
            function($delegate, decoratedPromiseBuilder, notificationService, CLOUD_ERRORS, loggingDecorator) {

                function errorIs(code) {
                    return function(error) {
                        return code === error.message;
                    };
                }

                var builder = decoratedPromiseBuilder.forDelegate($delegate);

                builder
                    .decorate('rename')
                    .onSuccess(notificationService.success('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.FOLDER_RENAMED'))
                    .onErrorIf(errorIs(CLOUD_ERRORS.DUPLICATE), notificationService.error('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.FOLDER_ALREADY_EXISTS'))
                    .onErrorIf(errorIs(CLOUD_ERRORS.FOLDER_NAME_EMPTY), notificationService.error('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.EMPTY_FOLDER_NAME'))
                    .onError(notificationService.error('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.RENAME_PROBLEM'));

                loggingDecorator.addLoggingWithBuilder(builder, functionsToDecorate);

                return builder.fork();
            }
        ]);
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/folders/folders.service.js
// module id = 453
// module chunks = 0